<template>
  <div class="gene-mutaion">
    <div class="cards-title">
      <span>{{ headName }}</span>
      <i class="iconfont icon-right_small titleView"></i>
      <span @click="cancerSpecies">{{ headView }}</span>
    </div>

    <div class="cards-shaw"></div>
    <!-- <Empty v-if="tableData.length <= 0" /> -->
    <div class="null-box" v-if="tableData.length <= 0">
      <van-empty
        class="custom-image"
        image-size="100px"
        :image="require('../../../assets/not.png')"
        description="未检出"
      />
    </div>

    <div v-else class="gene-mutaion-list">
      <div
        class="genne-mutaion-head"
        v-for="(item, index) in titleData"
        :key="index"
      >
        <span>{{ item.name }}</span>
        <span>{{ item.samplenum }}</span>
        <span class="nomal">{{ item.percentage }}</span>
      </div>
      <div
        class="genne-mutaion-content"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <span :style="{ color: color1 }" @click="handleClick1(item)">{{
          item.name
        }}</span>
        <span @click="handleClick2(item)">{{ item.samplenum }}</span>
        <span @click="handleClick3(item)">{{ item.percentage }}</span>
      </div>
      <div
        class="mutaion-tab-box"
        v-if="flag == true"
        @click="ceiliingAnalysis"
      >
        <div class="mutaion-tab">
          <span>点突变/拷贝数/基因重排分析</span>
          <i class="iconfont icon-right_small geneView"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import empty from "../../../components/empty.vue";
export default {
  components: { empty },
  props: {
    headName: String,
    headView: String,
    titleData: null,
    tableData: null,
    flag: Boolean,
    color: String,
    color1: String,
  },
  data() {
    return {
      type: "1",
    };
  },
  mounted() {},
  methods: {
    handleClick1(item) {
      let param = {
        name: "wdJiedu",
        type: "1",
        gene: item.name,
        proteinChange: "",
        tabIndex: "0",
        fromSource: "sv",
      };
      this.$emit("geneClick", param);
      let params = {
        name: "cancer",
        cancerOne: item.name,
      };
      this.$emit("cancerName", params);
    },
    handleClick2(item) {
      let param = {
        name: "wdJiedu",
        type: "0",
        gene: item.name,
        proteinChange: "",
        tabIndex: "1",
        fromSource: "sv",
      };
      this.$emit("geneYangban", param);
      this.$emit("aiYangben", {
        cancer: item.name,
        type: "hzList",
      });
    },
    handleClick3(item) {
      let param = {
        name: "wdJiedu",
        type: "0",
        gene: item.name,
        proteinChange: "",
        beiyong: item.samplenum,
        tabIndex: "1",
        fromSource: "cnv",
      };
      this.$emit("cnvClick", param);
    },
    cancerSpecies() {
      this.$emit("geneAll", { name: "geneAll", fromSource: "sv" });
      this.$emit("geneAi", { type: "8002", fromSource: "cancer" });
    },

    ceiliingAnalysis() {
      this.$emit("ceiliingAnalysis", { type: "8001" });
    },
  },
};
</script>
<style scoped lang="less">
/deep/.van-empty__description{
  margin-top: 0;
}
/deep/.van-empty{
  padding: 20PX 0 30PX;
}
.cards-title {
  height: 70px;
}
.titleView {
  float: right;
  line-height: 70px;
  margin-right: 25px;
  color: #4b84ff;
  font-size: 12px;
}
.geneView {
  float: right;
  line-height: 36px;
  margin-right: 13px;
  color: #4b84ff;
  font-size: 12px;
}
.cards-title > span:nth-of-type(1) {
  display: inline-block;
  font-size: 18px;
  font-family: @family;
  font-weight: 500;
  color: #2f354d;
  padding-left: 24px;
  line-height: 70px;
}

.cards-title > span:nth-of-type(2) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  float: right;
  margin-right: 3px;
  line-height: 70px;
}

.cards-shaw {
  display: inline-block;
  width: 343px;
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(52, 68, 132, 0) 0%,
    rgba(52, 68, 132, 0.1) 100%
  );
}

.gene-mutaion {
  width: 343px;
  height: auto;
  background: @background_color;

  border-radius: 10px;
  margin: 0 auto;
  margin-top: 20px;
}
.gene-mutaion-list {
  padding-bottom: 16px;
}
.genne-mutaion-head {
  height: 48px;
  background: @background_color;

  padding-left: 24px;
  padding-right: 24px;
}

.genne-mutaion-head > span {
  float: left;
  height: 48px;
  line-height: 48px;
  font-size: 15px;
  font-family: @family;
  font-weight: 500;
  color: #9095a7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.genne-mutaion-head > span:nth-of-type(1) {
  width: 50%;
}

.genne-mutaion-head > span:nth-of-type(2) {
  width: 30%;
}

.genne-mutaion-head > span:nth-of-type(3) {
  width: 20%;
}

.genne-mutaion-content {
  height: 48px;
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
}

.genne-mutaion-content span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 48px;
  font-size: 15px;
  font-weight: 400;
  color: #2f354d;
}

.mutaion-tab-box {
  margin-top: 10px;
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 14px;
}

.mutaion-tab {
  padding-left: 16px;
  height: 36px;
  background: #eef4ff;
  border-radius: 6px;
}

.mutaion-tab > span:nth-of-type(1) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  line-height: 36px;
}

.mutaion-tab > span:nth-of-type(2) {
  font-size: 12px;
  font-family: @family;
  font-weight: 400;
  color: #4b84ff;
  line-height: 36px;
  float: right;
  margin-right: 13px;
}
</style>
